import { Link } from "react-router-dom";
import InfoFooter from "./InfoFooter";
import QAFooter from "./QAFooter";
import ContactFooter from "./ContactFooter";
import Icon from "../../common/Icon";

export default function Footer() {
  return (
    <footer dir="rtl" className="relative px-3 pb-4 pt-10 sm:px-5 sm:pb-5">
      <div className="relative mx-auto max-w-[1380px] overflow-hidden rounded-[2.5rem] bg-ink text-white shadow-[0_40px_90px_-30px_rgba(7,21,15,0.7)]">
        {/* پس‌زمینه: خطوط زمین + نورهای رنگی */}
        <div className="pointer-events-none absolute inset-0 pitch-stripes" />
        <div className="pointer-events-none absolute inset-0 pitch-lines opacity-60" />
        <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-emerald-500/25 blur-[90px]" />
        <div className="pointer-events-none absolute -bottom-32 left-10 h-80 w-80 rounded-full bg-floodlight/15 blur-[100px]" />

        {/* دایره‌ی وسط زمین */}
        <div className="pointer-events-none absolute -bottom-40 left-1/2 h-[420px] w-[420px] -translate-x-1/2 rounded-full border border-white/[0.06]" />

        <div className="relative px-6 py-12 sm:px-10 lg:px-14">
          {/* نوار بالایی: شعار + دکمه */}
          <div className="flex flex-col items-start justify-between gap-6 border-b border-white/10 pb-10 lg:flex-row lg:items-center">
            <div>
              <p className="text-xs font-black text-floodlight">
                ⚽ فوتبال پاوه، حرفه‌ای‌تر از همیشه
              </p>
              <h3 className="mt-3 max-w-xl text-2xl font-black leading-[1.5] sm:text-3xl">
                همه‌ی فوتبال شهرستان،
                <span className="text-gradient-lime"> در یک سامانه</span>
              </h3>
            </div>

            <div className="flex flex-wrap gap-3">
              <Link
                to="/competitions"
                className="group inline-flex h-12 items-center gap-2 rounded-full bg-floodlight px-6 text-sm font-black text-ink shadow-lime transition hover:-translate-y-1 hover:bg-floodlight-300"
              >
                برنامه مسابقات
                <Icon
                  name="arrowLeft"
                  className="h-4 w-4 transition-transform group-hover:-translate-x-1"
                />
              </Link>

              <Link
                to="/contact"
                className="inline-flex h-12 items-center gap-2 rounded-full border border-white/20 bg-white/5 px-6 text-sm font-bold text-white backdrop-blur-md transition hover:-translate-y-1 hover:bg-white/10"
              >
                ارتباط با هیئت
              </Link>
            </div>
          </div>

          <div className="grid gap-10 pt-10 md:grid-cols-3">
            <InfoFooter />
            <QAFooter />
            <ContactFooter />
          </div>
        </div>

        <div className="relative border-t border-white/10">
          <div className="flex flex-col items-center justify-between gap-2 px-6 py-5 text-center text-xs text-white/45 sm:flex-row sm:px-10 lg:px-14">
            <span>© ۲۰۲۶ هیئت فوتبال شهرستان پاوه – تمامی حقوق محفوظ است.</span>
            <span className="inline-flex items-center gap-2">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-floodlight" />
              سامانه رسمی مسابقات و باشگاه‌ها
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
